import ModalPrivacyPolicy from "./ModalPrivacyPolicy.js";
export default ModalPrivacyPolicy;
